
export default {
    productData: {
        serialNumber: 'DA-HMS-008',
        name: 'Holzbalkendecke mit Schalldämmplatten l Aufbau 8',
        construction: {
        composition: [
            {
            type: 'screed',
            title: { de: 'Estrich' },
            output: 'ohne',
            value: 'w-0'
            },
            {
            type: 'soundInsulation',
            title: { de: 'Schalldämmplatte' },
            output: '2 x 12,5 mm',
            value: 'si-25'
            },
            {
            type: 'insulation',
            title: { de: 'Holzfaserdämmplatte' },
            output: '≥ 4',
            value: 'w-4'
            },
            {
            type: 'fill',
            title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 132 kg/m<sup>2</sup>), Rieselschutz' },
            output: '≥ 80',
            value: 'scsb-80'
            },
            {
            type: 'woodenPanel',
            title: { de: 'Holzwerkstoffplatte HW' },
            output: '≥ 22',
            value: 22
            },
            {
            type: 'supportingStructure',
            title: { de: 'Balken' },
            output: '240',
            value: 'b-240'
            },
            {
                type: 'suspendedCeiling',
                title: { de: 'Hohlraumdämpfung' },
                output: '2 x 120',
                value: 'h-240'
              },
            {
            type: 'suspendedCeiling',
            title: { de: 'Federschiene' },
            output: '25',
            value: 'f-25'
            },
            {
                type: 'soundInsulation',
                title: { de: 'Schalldämmplatte' },
                output: '12,5',
                value: 'g-12.5'
              },
              {
                type: 'suspendedCeiling',
                title: { de: 'Gipsplatte GKFI' },
                output: '12,5',
                value: 'g-12.5'
              }
        ],
        sum: {
            output: '421', value: 421
        }
        },
        technicalValues: {
        impactSoundLevel: { // L,nw
            output: '33 (2; 11)',
            value: 33
        },
        soundReductionIndex: { // Rw
            output: '83 (-3; -9)',
            value: 83
        },
        heatTransferCoefficient: { // U-Wert
            output: '0,20',
            value: 0.20
        },
        fireResistance: {
          output: '-', value: null
        },
        massPerUnitArea: {
          output: '245,6 [kg/m²]'
        }
        }
    },
    image: 'da-hms-008.png',
    pdf: 'Holzbalkendecke-mit-Schalldämmplatten-Aufbau-8-DA-HMS-008-Rev01.pdf'
    }
  
